const getAppContexts = (appUniqueName: string) => contextMap.get(appUniqueName)
export default getAppContexts

const contextMap = new Map([
  ['riskassessment', ['company', 'person', 'address']],
  ['properties', ['company', 'address']],
])
